export enum HEADLINE_ORIENTATION {
  SPLIT = 'split',
  STACKED = 'stacked',
}
